import { Button, Stack } from '@mui/material';
import { toast } from 'react-toastify';
import { services } from '@/constant/configure';
import { GoogleLogo, KakaoLogo, NaverLogo } from './ProviderLogos';

/**
 * 소셜 로그인 버튼 그룹 — 글로릴스 로그인 화면과 동일한 구성·순서(카카오 > 네이버 > 구글).
 *
 * 카카오/네이버는 provider 인가 URL 로 직접 이동한다(기존 방식 유지).
 * 글로릴스는 여기 없다 — 별개 로그인 수단이 아니라 로그인하면 자동으로 함께
 * 로그인되는 같은 계정이기 때문(eager 전파, services/sso.service.ts).
 * 구글은 소듀 백엔드에 `/login/google` 이 없어 아직 동작하지 않는다 —
 * 구색을 맞추기 위해 노출하되 누르면 준비 중임을 알린다.
 * 애플은 기존과 동일하게 숨긴다.
 */
export default function SocialLoginButtons({ refer }: { refer?: string | null }) {
    const { social } = services;
    const state = refer ?? '';

    const naverURL = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${social.naver_client_id}&redirect_uri=${social.naver_redirect_url}&state=${state}`;
    const kakaoURL = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${social.kakao_client_id}&redirect_uri=${social.kakao_redirect_url}&state=${state}`;

    // 하드웨어 가속 범위(transform/opacity)에서만 움직인다
    const pressable = {
        cursor: 'pointer',
        borderRadius: '12px',
        py: 1.35,
        fontWeight: 700,
        boxShadow: 'none',
        transition: 'transform .16s cubic-bezier(.2,.8,.2,1), opacity .16s ease',
        willChange: 'transform',
        '&:hover': { boxShadow: 'none', transform: 'translateY(-1px)' },
        '&:active': { transform: 'translateY(0) scale(0.985)' },
    } as const;

    return (
        <Stack spacing={1.25}>
            <Button
                fullWidth
                size="large"
                variant="contained"
                href={kakaoURL}
                startIcon={<KakaoLogo />}
                sx={{
                    ...pressable,
                    bgcolor: '#FEE500',
                    color: '#191919',
                    '&:hover': { ...pressable['&:hover'], bgcolor: '#F2DA00' },
                }}
            >
                카카오로 계속하기
            </Button>

            <Button
                fullWidth
                size="large"
                variant="contained"
                href={naverURL}
                startIcon={<NaverLogo />}
                sx={{
                    ...pressable,
                    bgcolor: '#03C75A',
                    color: '#ffffff',
                    '&:hover': { ...pressable['&:hover'], bgcolor: '#02B351' },
                }}
            >
                네이버로 계속하기
            </Button>

            <Button
                fullWidth
                size="large"
                variant="outlined"
                startIcon={<GoogleLogo />}
                onClick={() => toast.info('구글 로그인은 준비 중이에요.', { toastId: 'google-soon' })}
                sx={{ ...pressable, color: 'text.primary', borderColor: 'divider' }}
            >
                Google로 계속하기
            </Button>
        </Stack>
    );
}
